import {
  ArrowToLeft,
  ArrowToRightIcon,
  DashboardActive,
  DashboardInActive,
  HostActiveIcon,
  HostInActiveIcon,
  InboxActive,
  InboxInActive,
  LightIcon,
  NftsActive,
  NftsInActive,
  ReservationActive,
  ReservationInactive,
  TransactionsActive,
  TransactionsInActive,
  TravlerActive,
  TravlerInActive,
} from "../../../AssetComponents/Images"
import { SelectionGroup, SelectionItem } from "../../../Components/Selection/Selection"
import { TripsActive } from "../../../AssetComponents/Images"
import { TripsInActive } from "../../../AssetComponents/Images"
import { useState,useEffect } from "react"

export const StaticHostSidebar = () => {
  // Static state - always expanded on desktop, can be collapsed on mobile
   const [expanded, setExpanded] = useState(false) // Changed from true to false
  const mode = "host"
  const submode = "dashboard"
 
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setExpanded(false) // Always collapse on mobile
      } else {
        setExpanded(true) // Expand on desktop
      }
    }

    // Set initial state based on screen size
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div
      className={
        expanded
          ? "min-w-[250px] lg:min-w-[300px] bg-white h-full p-[8px] lg:p-[10px] flex flex-col"
          : "w-max bg-white h-full p-[8px] lg:p-[10px] flex flex-col"
      }
    >
      <>
        {mode === "host" && (
          <div
            className={
              expanded ? "flex items-center w-full justify-between" : "flex items-center w-full justify-center"
            }
          >
            {expanded && (
              <div className="flex items-center gap-[8px] lg:gap-[10px]">
                <div className="scale-75 lg:scale-100">
                  <HostActiveIcon />
                </div>
                <div className="text-sm lg:text-base">Host's Dashboard</div>
              </div>
            )}
            
            {/* Mobile toggle button */}
            <div
              onClick={() => setExpanded(!expanded)}
              className={
                expanded
                  ? "cursor-pointer hover:translate-x-[-4px] p-[3px] lg:p-[4px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)]"
                  : "cursor-pointer hover:translate-x-[4px] p-[3px] lg:p-[4px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)]"
              }
            >
              <div className="scale-75 lg:scale-100">
                {expanded ? <ArrowToLeft /> : <ArrowToRightIcon />}
              </div>
            </div>
          </div>
        )}

        <div className="h-full justify-between flex flex-col">
          {mode === "host" && (
            <SelectionGroup
              defaultItem={0}
              className="space-y-[3px] lg:space-y-[4px] mt-[16px] lg:mt-[20px]"
            >
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <DashboardActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Dashboard</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <DashboardInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Dashboard</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <ReservationActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Reservations</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <ReservationInactive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Reservations</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <NftsActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">My Real Estate NFTs</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <NftsInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">My Real Estate NFTs</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <TransactionsActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Transactions</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <TransactionsInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Transactions</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <InboxActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Inbox</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <InboxInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Inbox</div>}
                    </div>
                  </div>
                }
              />
            </SelectionGroup>
          )}

          {mode === "host" && (
            <SelectionGroup
              defaultItem={0}
              className={
                expanded
                  ? "w-full px-[5px] lg:px-[6px] py-[3px] lg:py-[4px] gap-[6px] lg:gap-[8px] flex items-center rounded-[12px] lg:rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                  : "w-full px-[5px] lg:px-[6px] py-[3px] lg:py-[4px] space-y-[6px] lg:space-y-[8px] items-center rounded-[12px] lg:rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
              }
            >
              <SelectionItem
                SelectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        : "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <HostActiveIcon />
                    </div>
                    {expanded && <div className="text-black font-semibold text-sm lg:text-base">Host</div>}
                    <div className="scale-75 lg:scale-100">
                      <LightIcon />
                    </div>
                  </div>
                }
                UnselectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center"
                        : "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <HostInActiveIcon />
                    </div>
                    {expanded && <div className="text-[#959595] text-sm lg:text-base">Host</div>}
                  </div>
                }
              />
              
              <SelectionItem
                SelectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        : "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <TravlerActive />
                    </div>
                    {expanded && <div className="text-black font-semibold text-sm lg:text-base">Traveler</div>}
                    <div className="scale-75 lg:scale-100">
                      <LightIcon />
                    </div>
                  </div>
                }
                UnselectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center"
                        : "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <TravlerInActive />
                    </div>
                    {expanded && <div className="text-[#959595] text-sm lg:text-base">Traveler</div>}
                  </div>
                }
              />
            </SelectionGroup>
          )}
        </div>
      </>
    </div>
  )
}

export const StaticTravelerSidebar = () => {
  // Static state - always expanded on desktop, can be collapsed on mobile
  const [expanded, setExpanded] = useState(false) // Changed from true to false
  const mode = "traveler"
  const submode = "dashboard"

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setExpanded(false) // Always collapse on mobile
      } else {
        setExpanded(true) // Expand on desktop
      }
    }

    // Set initial state based on screen size
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div
      className={
        expanded
          ? "min-w-[250px] lg:min-w-[300px] bg-white h-full p-[8px] lg:p-[10px] flex flex-col"
          : "w-max bg-white h-full p-[8px] lg:p-[10px] flex flex-col"
      }
    >
      <>
        {mode === "traveler" && (
          <div
            className={
              expanded ? "flex items-center w-full justify-between" : "flex items-center w-full justify-center"
            }
          >
            {expanded && (
              <div className="flex items-center gap-[8px] lg:gap-[10px]">
                <div className="scale-75 lg:scale-100">
                  <TravlerActive />
                </div>
                <div className="text-sm lg:text-base">Traveler's Dashboard</div>
              </div>
            )}
            <div
              onClick={() => setExpanded(!expanded)}
              className={
                expanded
                  ? "cursor-pointer hover:translate-x-[-4px] p-[3px] lg:p-[4px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)]"
                  : "cursor-pointer hover:translate-x-[4px] p-[3px] lg:p-[4px] w-max rounded-full shadow-[-2px_-2px_6px_0px_rgba(253,255,255,0.80),2px_2px_6px_0px_rgba(187,195,206,0.60)]"
              }
            >
              <div className="scale-75 lg:scale-100">
                {expanded ? <ArrowToLeft /> : <ArrowToRightIcon />}
              </div>
            </div>
          </div>
        )}

        <div className="h-full justify-between flex flex-col">
          {mode === "traveler" && (
            <SelectionGroup
              defaultItem={0}
              className="space-y-[3px] lg:space-y-[4px] mt-[16px] lg:mt-[20px]"
            >
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <DashboardActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Dashboard</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <DashboardInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Dashboard</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <TripsActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Trips</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <TripsInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Trips</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <TransactionsActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Transactions</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <TransactionsInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Transactions</div>}
                    </div>
                  </div>
                }
              />
              <SelectionItem
                SelectedItem={
                  <div className="cursor-pointer rounded-[14px] lg:rounded-[16px] shadow-[2px_2px_1px_0px_rgba(187,195,206,0.6),-2px_-2px_2px_0px_rgba(253,255,255,0.80),0px_1px_2px_0px_rgba(0,0,0,0.11)] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-[#F6F6F6]">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <InboxActive />
                      </div>
                      {expanded && <div className="text-sm lg:text-base">Inbox</div>}
                    </div>
                    {expanded && (
                      <div className="scale-75 lg:scale-100 mr-[4px] lg:mr-[6px]">
                        <LightIcon />
                      </div>
                    )}
                  </div>
                }
                UnselectedItem={
                  <div className="hover:bg-[#F6F6F6] cursor-pointer rounded-[14px] lg:rounded-[16px] flex items-center justify-between p-[5px] lg:p-[6px] py-[6px] lg:py-[8px] bg-white">
                    <div className="flex items-center gap-[6px] lg:gap-[8px]">
                      <div className="scale-75 lg:scale-100">
                        <InboxInActive />
                      </div>
                      {expanded && <div className="text-[#959595] text-sm lg:text-base">Inbox</div>}
                    </div>
                  </div>
                }
              />
            </SelectionGroup>
          )}

          {mode === "traveler" && (
            <SelectionGroup
              defaultItem={1}
              className={
                expanded
                  ? "w-full px-[5px] lg:px-[6px] py-[3px] lg:py-[4px] gap-[6px] lg:gap-[8px] flex items-center rounded-[12px] lg:rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                  : "w-full px-[5px] lg:px-[6px] py-[3px] lg:py-[4px] space-y-[6px] lg:space-y-[8px] items-center rounded-[12px] lg:rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
              }
            >
              <SelectionItem
                SelectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        : "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <HostActiveIcon />
                    </div>
                    {expanded && <div className="text-black font-semibold text-sm lg:text-base">Host</div>}
                    <div className="scale-75 lg:scale-100">
                      <LightIcon />
                    </div>
                  </div>
                }
                UnselectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center"
                        : "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <HostInActiveIcon />
                    </div>
                    {expanded && <div className="text-[#959595] text-sm lg:text-base">Host</div>}
                  </div>
                }
              />
              
              <SelectionItem
                SelectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        : "py-[3px] lg:py-[4px] cursor-pointer bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center gap-[8px] lg:gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <TravlerActive />
                    </div>
                    {expanded && <div className="text-black font-semibold text-sm lg:text-base">Traveler</div>}
                    <div className="scale-75 lg:scale-100">
                      <LightIcon />
                    </div>
                  </div>
                }
                UnselectedItem={
                  <div
                    className={
                      expanded
                        ? "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-[110px] lg:w-[130px] flex justify-center"
                        : "py-[3px] lg:py-[4px] gap-[8px] lg:gap-[10px] cursor-pointer hover:bg-[#f6f6f6] rounded-[8px] lg:rounded-[10px] w-max flex justify-center"
                    }
                  >
                    <div className="scale-75 lg:scale-100">
                      <TravlerInActive />
                    </div>
                    {expanded && <div className="text-[#959595] text-sm lg:text-base">Traveler</div>}
                  </div>
                }
              />
            </SelectionGroup>
          )}
        </div>
      </>
    </div>
  )
}

